var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.139 14.4H8.68204L5.75447 16.7748C5.55837 16.9339 5.26547 16.7944 5.26547 16.5419V14.4H4C2.89543 14.4 2 13.5046 2 12.4V6.04004C2 4.93547 2.89543 4.04004 4 4.04004L14.56 4.04004C15.6646 4.04004 16.56 4.93547 16.56 6.04004V10.4889",
    stroke: "#666666",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79873 6.88253L7.09521 11.3379H7.87521L8.28081 10.2209H10.1466L10.5522 11.3379H11.3322L9.62865 6.88253H8.79873ZM8.49921 9.62189L9.20433 7.66877H9.22929L9.92817 9.62189H8.49921Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3931 17.9843V15.904H17.2131H17.9775V12.7517H15.3931V11.5068H14.6069V12.7517H12.0298V15.904H12.7942H14.6069V17.9843H15.3931ZM14.6067 15.1613H12.7939V13.4941H14.6067V15.1613ZM15.3931 15.1613H17.2131V13.4941H15.3931V15.1613Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavEn);
export default __webpack_public_path__ + "static/media/nav-en.290c2f545df59057cb53b796f0576c0a.svg";
export { ForwardRef as ReactComponent };